import primaryNav from './primary-nav';
export default primaryNav;